import functions from "@/utils/functions";

export default {

  getToken() {
    return localStorage.getItem('token')
  },

  getRefToken() {
    return localStorage.getItem('ref_token')
  },

  getDataExpiredToken() {
    return localStorage.getItem('exp_data')
  },

  getAuthHeader() {
    return 'Bearer ' + this.getToken()
  },


  checkRemember() {
    return !!localStorage.getItem('ref_token')
  },

  checkAuth() {
    return !!localStorage.getItem('token')
  },


  getExpiration(tokenExpiration) {

    var now = new Date();
    now.setMinutes(now.getMinutes() + Math.ceil((tokenExpiration / 60)))

    return functions.formatDateTime(now);
  },

  setStorageAuth(data) {

    localStorage.setItem('token', data.access_token);
    localStorage.setItem('exp_data', this.getExpiration(data.expires_in))

    if (data.refresh_token)
      localStorage.setItem('ref_token', data.refresh_token)
  },


  clearStorage() {
    localStorage.clear();
  },


/*   setUtente(data) {
    localStorage.setItem('utente', data);
  },

  getUtente() {
    return localStorage.getItem('utente')
  }, */


  setConsegne(data) {
    let arr = this.getConsegne()
    arr.push(data)
    localStorage.setItem('consegne', JSON.stringify(arr));
  },
  getConsegne() {
    return JSON.parse(localStorage.getItem('consegne')) || []
  },
  delConsegne() {
    localStorage.removeItem('consegne');
  },


  setGps(data) {
    let arr = this.getGps()
    arr.push(data)
    localStorage.setItem('gps', JSON.stringify(arr));
  },
  getGps() {
    return JSON.parse(localStorage.getItem('gps')) || []
  },
  delGps() {
    localStorage.removeItem('gps');
  },

}